import React from 'react';
import './RewardsSection.css';

const RewardsSection = () => {
  return (
    <section className="rewards-section motion-section">
      {/* Background Floating Decorative Coins & Dots */}
      <div className="coin-bg float-c1">🪙</div>
      <div className="coin-bg float-c2">💰</div>
      <div className="coin-bg float-c3">🪙</div>
      <div className="coin-bg float-c4">🪙</div>
      <div className="coin-bg float-c5">💰</div>
      <div className="particle-dot p-dot1"></div>
      <div className="particle-dot p-dot2"></div>
      <div className="particle-dot p-dot3"></div>

      <div className="rewards-container">
        {/* LEFT CONTENT COLUMN */}
        <div className="rewards-content">
          <h2 className="rewards-title">Make every transaction work harder.</h2>
          <p className="rewards-description">
            Pay, save, and unlock benefits while your wallet stays in sync. Earn points on everyday activity and redeem them when it matters.
          </p>

          <div className="rewards-cards-grid">
            {/* Card 1: Rewards Program */}
            <div className="reward-info-card">
              <div className="badge-ribbon-icon">
                <svg viewBox="0 0 48 48" className="badge-svg">
                  <circle cx="24" cy="20" r="14" fill="#FBBF24" stroke="#D97706" strokeWidth="3" />
                  <path d="M 16 30 L 12 44 L 20 40 L 24 44 L 20 31" fill="#F59E0B" stroke="#B45309" strokeWidth="2" />
                  <path d="M 32 30 L 36 44 L 28 40 L 24 44 L 28 31" fill="#D97706" stroke="#92400E" strokeWidth="2" />
                  <circle cx="24" cy="20" r="8" fill="#FEF3C7" />
                  <path d="M 24 14 L 26 18 L 30 18 L 27 21 L 28 25 L 24 22 L 20 25 L 21 21 L 18 18 L 22 18 Z" fill="#D97706" />
                </svg>
              </div>
              <div className="card-text">
                <h3>ATZ Rewards Program</h3>
                <p>Join our tier-based points system.</p>
              </div>
            </div>

            {/* Card 2: Partner Offers */}
            <div className="reward-info-card">
              <div className="brand-logos-row">
                <div className="partner-logo logo-blue">
                  <span>&amp;</span>
                </div>
                <div className="partner-logo logo-orange">
                  <span>G#</span>
                </div>
                <div className="partner-logo logo-dark">
                  <span>≡</span>
                </div>
              </div>
              <div className="card-text">
                <h3>Partner Offers</h3>
                <p>Exclusive deals with top brands.</p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT CONTENT COLUMN: Tablet / Device Preview */}
        <div className="rewards-device-wrapper">
          <div className="tablet-frame">
            {/* Tablet Header Bar */}
            <div className="tablet-header">
              <div className="user-profile">
                <img src="https://i.pravatar.cc/100?img=32" alt="User Avatar" className="profile-img" />
              </div>
              <div className="header-actions">
                <span className="action-icon">📬</span>
                <span className="action-icon">🔄</span>
              </div>
            </div>

            {/* Main Title inside Dashboard */}
            <div className="dash-title-row">
              <h3>Reward Dashboard</h3>
              <span className="tier-pill">Tier Active</span>
            </div>

            <div className="dash-body-grid">
              {/* Left Column: Progress Tracking */}
              <div className="dash-progress-col">
                <span className="dash-section-label">Active Dashboard</span>

                <div className="progress-item">
                  <div className="progress-header">
                    <span>Progress</span>
                    <span className="val-cyan">100%</span>
                  </div>
                  <div className="track-bar">
                    <div className="fill-bar bg-cyan" style={{ width: '100%' }}></div>
                  </div>
                </div>

                <div className="progress-item">
                  <div className="progress-header">
                    <span>Progress Tier</span>
                    <span className="val-pink">35%</span>
                  </div>
                  <div className="track-bar">
                    <div className="fill-bar bg-pink" style={{ width: '35%' }}></div>
                  </div>
                </div>

                <div className="progress-item">
                  <div className="progress-header">
                    <span>Progress</span>
                    <span className="val-green">0%</span>
                  </div>
                  <div className="track-bar">
                    <div className="fill-bar bg-green" style={{ width: '0%' }}></div>
                  </div>
                </div>
              </div>

              {/* Right Column: Gift Cards */}
              <div className="dash-cards-col">
                <span className="dash-section-label">Gift Cards</span>

                {/* Gift Card 1 */}
                <div className="gift-card-graphic card-blue-gradient">
                  <div className="ribbon-h"></div>
                  <div className="ribbon-v"></div>
                  <div className="gift-bow">🎁</div>
                </div>

                {/* Gift Card 2 */}
                <div className="gift-card-graphic card-pink-gradient">
                  <div className="ribbon-h"></div>
                  <div className="ribbon-v"></div>
                  <div className="card-sparkles">✨</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RewardsSection;